// eslint-disable-next-line
export const SET_STATUS = 'reload-configuration/set-status';
export const SET_RELOAD_INFO = 'reload-configuration/set-reload-info';
export const SET_LOADING = 'reload-configuration/set-loading';
